/**
 * The Cloudflare Turnstile contract of the Music24 email-code sign-in (web app only).
 *
 * The web app runs the invisible widget on the email step and sends its token with
 * `auth.requestCode` and `auth.resendCode`. music24-api checks the token with Cloudflare
 * siteverify. The native apps send no token: the server knows them by `x-appinfo-platform`.
 */

/** The `action` of the widget. The server refuses a token with another action. */
export const TURNSTILE_EMAIL_CODE_ACTION = 'email_code';

/**
 * The error type of a refused check. A client reads it from `error.data.errorType`; `error.data.code`
 * stays tRPC's own `FORBIDDEN`.
 */
export const TURNSTILE_FAILED_ERROR = 'M24_TURNSTILE_FAILED';

/** The longest token Cloudflare gives is 2048 characters. */
export const TURNSTILE_TOKEN_MAX_LENGTH = 2048;
